interface SizeObject {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  _2xl: string;
}

export function transformObjectToArray(obj: SizeObject) {
  return Object.entries(obj).map(([key, value]) => ({ [key]: value }));
}